module.exports = __webpack_public_path__ + "static/media/orderIcon.3dbee23a.png";